





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Qualifications from '@/components/Qualifications/Qualifications.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyQualificationSettings',
  	components: { Qualifications, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getQualifications();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingQualifications;
  	}
}
